import { Text } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Text
        color={"#FFFFFF"}
        textShadow={"3px 3px 3px #9C9C9C"}
        fontSize='md'
        backgroundColor={"#734A91"}
        padding="30px"
        alignItems={"center"}
        textAlign={"center"}
        marginTop={"auto"}
    >
        Feito com ❤️ por grupo 27
    </Text>
  );
};

export default Footer;
